import React, { useMemo } from 'react';

import { calculateDaysUntilExpiration, parseExpirationDates } from './helpers';
import { IGameLabels, ILabelsFeatureIconsProps } from './types';

import style from '@core/js/components/common/Game/Game.scss';

const DEFAULT_LABELS: IGameLabels = {
    isActiveGameNew: true,
    isActiveGamePopular: true,
    isActiveGameHot: true,
    isActiveGameExclusive: true
};

export const LabelsFeatureIcons: React.FC<ILabelsFeatureIconsProps> = ({
    t,
    isGameNew,
    isGamePopular,
    isGameHot,
    isGameExclusive,
    description,
    name,
    code
}) => {
    const {
        isActiveGameNew,
        isActiveGamePopular,
        isActiveGameHot,
        isActiveGameExclusive
    } = useMemo(() => {
        if (typeof description !== 'string' || !description.includes('expirationDate')) {
            return DEFAULT_LABELS;
        }

        const expirationDates = parseExpirationDates(description, name, code);

        return Object.entries(expirationDates).reduce((result, [label, date]) => {
            result[label as keyof IGameLabels] = Boolean(calculateDaysUntilExpiration(date));

            return result;
        }, { ...DEFAULT_LABELS });
    }, [code, description, name]);

    return (
        <>
            {isGameNew && isActiveGameNew && (
                <span className={style.label}>
                    {t('playtech.mobile.responsivegames.game.label.new')}
                </span>
            )}

            {isGamePopular && isActiveGamePopular && (
                <span className={style.label}>
                    {t('playtech.mobile.responsivegames.game.label.popular')}
                </span>
            )}

            {isGameHot && isActiveGameHot && (
                <span className={style.label}>
                    {t('playtech.mobile.responsivegames.game.label.hot')}
                </span>
            )}

            {isGameExclusive && isActiveGameExclusive && (
                <span className={style.label}>
                    {t('playtech.mobile.responsivegames.game.label.exclusive')}
                </span>
            )}
        </>
    );
};
